export const GET_CHECKLISTS_BY_TASK = "GET_CHECKLISTS_BY_TASK";
export const GET_CHECKLIST_TEMPLATES = "GET_CHECKLIST_TEMPLATES";
export const GET_CHECKLIST_BY_NODEID = "GET_CHECKLIST_BY_NODEID";
export const UPDATE_CHECKLIST = "UPDATE_CHECKLIST";
export const SUBMIT_CHECKLIST_REPORT = "SUBMIT_CHECKLIST_REPORT";
export const SAVE_CHECKLIST_ITEM_ANSWER = "SAVE_CHECKLIST_ITEM_ANSWER";
export const GET_CHECKLIST_REPORTS = "GET_CHECKLIST_REPORTS";
export const GET_CHECKLIST_REPORT = "GET_CHECKLIST_REPORT";
export const DELETE_CHECKLIST_TEMPLATE = "DELETE_CHECKLIST_TEMPLATE";

export const getChecklistsByTask = (maintenancetasknodeid, lang, op) => {
  return {
    type: GET_CHECKLISTS_BY_TASK,
    payload: { maintenancetasknodeid, lang },
    optype: op
  };
};

export const getChecklistTemplates = (legalentitynodeid, lang, op) => {
  return {
    type: GET_CHECKLIST_TEMPLATES,
    payload: { legalentitynodeid, lang },
    optype: op
  };
};

export const getChecklistByNodeId = (nodeid, lang, showpastanswers, op) => {
  return {
    type: GET_CHECKLIST_BY_NODEID,
    payload: { nodeid, lang, showpastanswers },
    optype: op
  };
};

// Standalone, in-place edit of a checklist's own definition (name/comment/
// items) via PUT /checklists/:nodeid — unlike editing through the
// maintenancetask payload, this does NOT clone/recreate the checklist and
// does NOT touch its report history. Only valid for a checklist that already
// has a nodeid; use only when nothing else on the maintenancetask changed.
export const updateChecklist = (nodeid, data, op) => {
  return {
    type: UPDATE_CHECKLIST,
    payload: { nodeid, data },
    optype: op
  };
};

export const submitChecklistReport = (nodeid, data, op) => {
  return {
    type: SUBMIT_CHECKLIST_REPORT,
    payload: { nodeid, data },
    optype: op
  };
};

// Saves one item's answer incrementally into the checklist's current
// in-progress report (PUT /checklists/:nodeid/reports/current) — creates a
// fresh report on the first save, upserts into it on subsequent saves.
export const saveChecklistItemAnswer = (checklistNodeId, item, op) => {
  return {
    type: SAVE_CHECKLIST_ITEM_ANSWER,
    payload: { checklistNodeId, item },
    optype: op
  };
};

export const getChecklistReports = (nodeid, op) => {
  return {
    type: GET_CHECKLIST_REPORTS,
    payload: { nodeid },
    optype: op
  };
};

export const getChecklistReport = (nodeid, op) => {
  return {
    type: GET_CHECKLIST_REPORT,
    payload: { nodeid },
    optype: op
  };
};

// Deletes a checklist template (its haschecklisttemplate relation to the
// legal entity) via DELETE /checklisttemplates/:nodeid — the template object
// itself stays in KH, same known limitation as the maintenance-task-template
// delete this mirrors.
export const deleteChecklistTemplate = (nodeid, legalentitynodeid, op) => {
  return {
    type: DELETE_CHECKLIST_TEMPLATE,
    payload: { nodeid, legalentitynodeid },
    optype: op
  };
};
